import Registry from '@core/registry';
export var LDProject = /*#__PURE__*/ function(LDProject) {
    LDProject[LDProject["SEARCH_PAGES"] = 0] = "SEARCH_PAGES";
    LDProject[LDProject["PLATFORM"] = 1] = "PLATFORM";
    LDProject[LDProject["CUSTOMER_SERVICE"] = 2] = "CUSTOMER_SERVICE";
    LDProject[LDProject["SEARCH_INTERFACES"] = 3] = "SEARCH_INTERFACES";
    LDProject[LDProject["COMMERCE_SERVICE"] = 4] = "COMMERCE_SERVICE";
    return LDProject;
}({});
/**
 * Returns the correct LaunchDarkly project client.
 *
 * @param {Record<LDProject, LaunchDarklyProject> | undefined} launchDarkly The LaunchDarkly instance.
 * @param {LDProject} project
 *
 * @returns {LaunchDarklyProject | undefined} The LaunchDarkly project client or undefined.
 */ var getProjectClient = function getProjectClient(launchDarkly, project) {
    if (!launchDarkly) {
        return undefined;
    }
    return launchDarkly[project];
};
export var LaunchDarklyFeatureFlags = {
    /**
     * Checks whether a feature flag is active.
     *
     * **Important Note:**
     * - This helper is intended for *simple* boolean/string flags where a
     * true/false or non-empty/empty string check is sufficient.
     *
     * For more complex flag evaluations, use {@link getValue} instead.
     *
     * @param {string} flag The feature flag to check.
     * @param {LDProject} [project=LDProject.PLATFORM] The project to check the flag against.
     * @returns {boolean} True if the flag is active, false otherwise.
     */ isActive: function isActive(flag) {
        var project = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        try {
            var _launchDarkly_project;
            var launchDarkly = Registry.get('launchDarkly');
            // Support both new bridge shape (numeric keys) and old LaunchDarkly class (named properties)
            var ldProject = (_launchDarkly_project = launchDarkly[project]) !== null && _launchDarkly_project !== void 0 ? _launchDarkly_project : getProjectClient(launchDarkly, project);
            return Boolean(ldProject === null || ldProject === void 0 ? void 0 : ldProject.checkFeatureFlag(flag));
        } catch (e) {
            return false;
        }
    },
    getProjectClient: getProjectClient
};

//# sourceMappingURL=LaunchDarklyFeatureFlags.js.map